import { useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AppLoader from "../components/Loaders/AppLoader";
import { useAuthentication } from "../features/Authentication/context";
import { useRouteConfig } from "./config";
import { usePreferenceQuery } from "../features/Settings/Configuration/api/usePreferenceQuery";

function Routing() {
	const config = useRouteConfig();
	const { authenticating, hasAuthenticated, token } = useAuthentication();

	usePreferenceQuery();

	const router = useMemo(() => {
		return createBrowserRouter(config)
	}, [config]);

	if (authenticating || (!hasAuthenticated && token)) {
		return <AppLoader />;
	}
	return <RouterProvider router={router} />;
}

export default Routing;
